//导入文件夹中的文件
let context = require.context('./modules', true, /\.js$/)
//自动注册路由
export let routes = context.keys().reduce((routes, filePath) => {
	routes.push(...context(filePath).default)
	return routes
}, [])
